{
  "reservationMasterTableConfig": {
    "columns": [
      {
        "fieldName": "name",
        "displayName": "Reservation Name",
        "dataType": "STRING"     
      },
      {
        "fieldName": "customer.name",
        "displayName": "Customer Name",
        "dataType": "STRING",
        "thStyleConfig": {
          "width": "300px"
        }     
      },
      {
        "fieldName": "warehouse.name",
        "displayName": "Warehouse Name",
        "dataType": "STRING",
        "thStyleConfig": {
          "width": "200px"
        }         
      },
      {
        "fieldName": "reservedVolume",
        "displayName": "Reserved Volume (sq mt)",
        "dataType": "STRING",
        "thStyleConfig": {
          "width": "140px"
        },
        "styleConfig": {
          "type": "badge",
          "conditions": [
            {
              "expression": "eq(value, undefined)",
              "styleProperties": {
                "display": "none"
              }
            }
          ],
          "styleProperties": {
            "width": "100px",
            "display": "flex",
            "align-items": "center",
            "border-radius": "6px",
            "border": "1px solid #D0D5DD",
            "background": "var(--Gray-100, #F2F4F7)",
            "box-shadow": "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
            "color": "var(--Gray-700, #344054)",
            "text-align": "center",
            "font-family": "Inter",
            "font-size": "12px",
            "font-style": "normal",
            "font-weight": "500",
            "line-height": "18px"
          }
        }
      },
       {
        "fieldName": "active",
        "displayName": "Status",
        "dataType": "BOOLEAN",
        "valueMap": {
          "true": "Active",
          "false": "Inactive"
        },
        "thStyleConfig": {
          "width": "60px"
        },
        "styleConfig": {
          "type": "status"
        }
      },   
      {
        "fieldName": "fromDate",
        "displayName": "From",
        "dataType": "DATETIME"
      },
      {
        "fieldName": "toDate",
        "displayName": "To",
        "dataType": "DATETIME"
      }, 
      {
        "fieldName": "remarks",
        "displayName": "Remarks",
        "dataType": "STRING",
        "thStyleConfig": {
          "width": "300px"
        }         
      },
      {
        "fieldName": "modifiedBy",
        "displayName": "Modified By",
        "dataType": "STRING",
        "styleConfig": {
          "type": "user-avatar"
        }
      }  
     
    ]
  },
  "filterConfig": {
    "filterFields": [
      {
        "name": "CUSTOMER_EQUALS",
        "displayLabel": "Customer Name",
        "dataType": "STRING",
        "operatorToFilterMap": {
          "CONTAINS": "CUSTOMER_EQUALS"
        }
      },
      {
        "name": "WAREHOUSE_EQUALS",
        "displayLabel": "Warehouse Name",
        "dataType": "STRING",
        "operatorToFilterMap": {
          "CONTAINS": "WAREHOUSE_EQUALS"
        }
      },
      {
        "name": "ACTIVE_EQUALS",
        "displayLabel": "Active",
        "dataType": "BOOLEAN",
        "operatorToFilterMap": {
          "EQ": "ACTIVE_EQUALS"
        }
      }
    ],
    "useNewContract": true
  },

  "searchBarConfig": {
    "placeHolder": "Search Reservation by name",
    "filters": [
      {
        "name": "NAME_CONTAINS",
        "alias": "reservation_name"
      }
    ]
  },

  "formControls": {
    "formRows": [
      {
        "formGroups": [
          {
            "style": {
              "gridColumn": "span 6"
            },
            "control": {
              "label": "name",
              "displayLabel": "Reservation Name",
              "placeHolder": "Enter Reservation Name",
              "fieldInfo": {
                "dataType": "string"
              }
            }
          }
        ]
      },
      {
        "formGroups": [
          {
            "style": {
              "gridColumn": "span 6"
            },
            "control": {
              "label": "fromDate",
              "displayLabel": "From Date",
              "placeHolder": "Select From Date",
              "fieldInfo": {
                "dataType": "datetime-local"
              },
              "validators": [
                {
                  "type": "required",
                  "message": "From Date must be selected"
                }
              ]
            }
          },
          {
            "style": {
              "gridColumn": "span 6"
            },
            "control": {
              "label": "toDate",
              "displayLabel": "To Till",
              "placeHolder": "Select to till Date",
              "fieldInfo": {
                "dataType": "datetime-local"
              },
              "validators": [
                {
                  "type": "required",
                  "message": "To Date must be selected"
                }
              ]
            }
          }
        ]
      },

      {
        "formGroups": [
     {
            "style": {
              "gridColumn": "span 6"
            },
            "control": {
              "label": "warehouse",
              "displayLabel": "Warehouse Name",
              "placeHolder": "Select Warehouse",
              "fieldInfo": {
                "dataType": "picklist",
                "lookupDetails": {
                  "apiUrl": "v1/warehouses/list",
                  "filterByKeys": ["NAME_CONTAINS"],
                  "limit": 10,
                  "orderBy": { "name": "asc" },
                  "bindLabel": "name",
                  "bindValue": "id",
                  "returnRawValue":false,
                  "additionalFilters": [
                    {
                      "name": "IS_ACTIVE",
                      "alias": "active",
                      "operator": "EQ",
                      "value": ["true"]
                    }
                  ],
                  "displayColumns": [{ "key": "name", "header": "Name" }]
                }
              },
              "validators": [
                {
                  "type": "autocompleteRequired",
                  "message": "Warehouse Name is required"
                }
              ]
            }
          },
          {
            "style": {
              "gridColumn": "span 6"
            },
            "control": {
                    "label": "customer",
                    "displayLabel": "Customer",
                    "placeHolder": "Select Customer",
                    "fieldInfo": {
                      "dataType": "picklist",
                      "lookupDetails": {
                        "apiUrl": "v1/customers/list",
                        "filterByKeys": ["NAME_CONTAINS"],
                        "additionalFilters": [
                          {
                            "name": "IS_ACTIVE",
                            "alias": "active",
                            "operator": "EQ",
                            "value": ["true"]
                          }
                        ],
                        "limit": 10,
                        "orderBy": { "name": "asc" },
                        "bindLabel": "name",
                        "bindValue": "id",
                        "returnRawValue":false, 
                        "displayColumns": [
                          { "key": "name", "header": "Name" }
                        ]
                        
                      }
                    },
                    "validators": [
                      {
                          "type": "autocompleteRequired",
                          "message": "Customer is required"
                      }
                    ]
                  }
          }
        ]
      },

      {
        "formGroups": [
          {
            "style": {
              "gridColumn": "span 6"
            },
            "control": {
              "label": "reservedVolume",
              "displayLabel": "Reservation Volume (sq mt)",
              "placeHolder": "Enter Volume",
              "fieldInfo": {
                "dataType": "number"
              },
              "validators": [
                {
                  "type": "required",
                  "message": "volume is required"

                },
                {
                  "type": "min",
                  "message": "Volume should be Greater than 0",
                  "params": 1
                }
                
              ]
            }
          },
     
                {
            "style": {
              "gridColumn": "span 6"
            },
            "control": {
              "label": "active",
              "displayLabel": "Active",
              "skipLabel": true,
              "defaultValue": true,
              "fieldInfo": {
                "dataType": "boolean"
              }
            }
          }
        ]
      },

      {
        "formGroups": [
          {
            "style": {
              "gridColumn": "span 12"
            },
            "control": {
              "label": "remarks",
              "displayLabel": "Remarks",
              "placeHolder": "Enter Remarks",
              "fieldInfo": {
                "dataType": "textarea"
              }
            }
          }
        ]
      }

    ]
  }
}
